const ragColors = {
    NONE: 0,
    GREEN: 1,
    AMBER: 2,
    RED: 3,
} as const;

export default ragColors;
